import { useTranslation } from "react-i18next";
import { useAppDispatch } from "@/services/store";
import { WIDGET_CONTENTS_IDS, WIDGETS } from "../../constants";
import { addWidget } from "../../slice";
import { Bookmark } from "./Bookmark";
import styles from "./styles.module.scss";

export const ControlSidebar = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const addWidgetHandler = (widgetContentId: number) => {
    dispatch(
      addWidget({
        id: `widget${Math.floor(Math.random() * 100)}`,
        x: 0,
        y: 0,
        w: WIDGETS[widgetContentId].minW,
        h: WIDGETS[widgetContentId].minH,
        widgetContentId: widgetContentId,
      }),
    );
  };
  return (
    <div className={styles["bookmark-wrapper"]}>
      <Bookmark
        onClick={() => addWidgetHandler(WIDGET_CONTENTS_IDS.COMMITMENTS_TABLE)}
        title={t("common.noteType.commitment", { count: 2 })}
      />
      <Bookmark
        onClick={() => addWidgetHandler(WIDGET_CONTENTS_IDS.NOTES_TABLE)}
        title={t("common.noteType.note", { count: 2 })}
      />
      <Bookmark
        onClick={() => addWidgetHandler(WIDGET_CONTENTS_IDS.CONTACTS_BAR)}
        title={t("common.contacts")}
      />
      <Bookmark
        onClick={() => addWidgetHandler(WIDGET_CONTENTS_IDS.CALENDAR)}
        title={t("common.calendar")}
      />
    </div>
  );
};
